var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Login'),(_vm.showPasswordDialog)?_c('PasswordChangeDialog'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }